/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});




// =============================================================================================================================
// document.addEventListener('DOMContentLoaded', function () {
//   const tabs = document.querySelectorAll('.tab-link');
  
//   // Function to set the active tab based on the current URL
//   function setActiveTab() {
//     const currentUrl = window.location.href;
//     let activeTabSet = false;

//     tabs.forEach(function (tab) {
//       const collection = tab.getAttribute('data-collection');
      
//       // Check if the current URL ends with the collection
//       if (currentUrl.endsWith('/' + collection)) {
//         tab.classList.add('active');
//         activeTabSet = true;
//       } else {
//         tab.classList.remove('active');
//       }
//     });

//     // If no specific tab is matched, default to "All"
//     if (!activeTabSet) {
//       const allTab = document.querySelector('[data-collection="all"]');
//       if (allTab) {
//         allTab.classList.add('active');
//       }
//     }
//   }

//   // Call the function to initialize the active tab
//   setActiveTab();

//   // Add click event listeners to each tab
//   tabs.forEach(function (tab) {
//     tab.addEventListener('click', function () {
//       // Remove the 'active' class from all tabs
//       tabs.forEach(function (tab) {
//         tab.classList.remove('active');
//       });

//       // Add 'active' class to the clicked tab
//       tab.classList.add('active');

//       // Get the collection from the data-attribute
//       const collection = tab.getAttribute('data-collection');
//       const currentUrl = window.location.href;
//       const newUrl = currentUrl.replace(/\/[^\/]+$/, '/' + collection);

//       // Update the browser URL without refreshing the page
//       history.pushState({ path: newUrl }, '', newUrl);
//     });
//   });
// });



//   document.addEventListener("DOMContentLoaded", function () {
//     // Get the current URL
//     const currentURL = window.location.href;

//     // Select all tab buttons
//     const tabLinks = document.querySelectorAll(".tab-link");

//     // Loop through each tab
//     tabLinks.forEach((tab) => {
//       // Get the data-collection value of the tab
//       const collection = tab.getAttribute("data-collection");

//       // Check if the current URL contains the collection value
//       if (currentURL.includes(collection)) {
//         // Remove 'active' class from all tabs
//         tabLinks.forEach((tab) => tab.classList.remove("active"));

//         // Add 'active' class to the matched tab
//         tab.classList.add("active");
//       }
//     });
//   });


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-link");
  const currentPath = window.location.pathname;

  tabs.forEach(tab => {
    const collection = tab.getAttribute("data-collection");
    if (currentPath.includes(`/collections/${collection}`)) {
      tabs.forEach(t => t.classList.remove("active")); // Remove active from all
      tab.classList.add("active"); // Add active to the current one
    }
  });
});


// Select all tab links and the message elements
const tabs = document.querySelectorAll('.tab-link');
const messageContainer = document.getElementById('message');
const message1 = document.getElementById('message1');
const message2 = document.getElementById('message2');
const message3 = document.getElementById('message3');

// Function to display messages based on active tab
function displayMessages(activeTab) {

  console.log(messageContainer)
  if(!messageContainer){
    return;
  }

  if (activeTab === 'mint') {
    messageContainer.style.display = 'block';
    message1.textContent = 'Low Dose';
    message2.textContent = 'Portable & Discreet';
    message3.textContent = 'Smooth Effect';
  } else if (activeTab === 'shots') {
    messageContainer.style.display = 'block';
    message1.textContent = 'Quicker Onset';
    message2.textContent = 'Moderate Dose';
    message3.textContent = 'Smooth Effect';
  } else {
    messageContainer.style.display = 'none';
    message1.textContent = '';
    message2.textContent = '';
    message3.textContent = '';
  }
}

// Function to highlight the active tab
function setActiveTab(activeTab) {
  tabs.forEach(tab => {
    if (tab.getAttribute('data-collection') === activeTab) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
  });
}

// Function to determine the active tab based on the current URL
function getActiveTabFromURL() {
  const urlPath = window.location.pathname;
  if (urlPath.includes('/collections/mint')) {
    return 'mint';
  } else if (urlPath.includes('/collections/shots')) {
    return 'shots';
  } else if (urlPath.includes('/collections/gummies')) {
    return 'gummies';
  } else if (urlPath.includes('/collections/bundles')) {
    return 'bundles';
  } else {
    return 'all';
  }
}

// On page load, determine the active tab from the URL or localStorage
document.addEventListener('DOMContentLoaded', () => {
  const activeTab = getActiveTabFromURL();
  localStorage.setItem('activeTab', activeTab); // Save the current tab for consistency
  setActiveTab(activeTab);
  displayMessages(activeTab);
});

// Add click event listeners to all tab links
tabs.forEach(tab => {
  tab.addEventListener('click', function () {
    const activeTab = tab.getAttribute('data-collection');
    console.log(activeTab)
    localStorage.setItem('activeTab', activeTab); // Update localStorage with the clicked tab
    setActiveTab(activeTab);
    displayMessages(activeTab);
    // Allow redirection to happen naturally
  });
});





// =================================================================================================================